// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/ban.js';

import { paths } from '../generated/ban';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('ban', Original, paths);
